/* eslint-disable react-hooks/exhaustive-deps */
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './style.css';
import { Box, Button, Typography } from '@material-ui/core';
import en from 'date-fns/locale/en-GB';
import ar from 'date-fns/locale/ar-SA';

const CalenderRange = ({ start, setStart, setEnd, isRTL, label }: any) => {
  const onChange = (date: any) => {
    if (!date) return;
    const dst = new Date(date);
    const den = new Date(date);
    dst.setHours(0, 0, 0, 0);
    den.setHours(23, 59, 59, 999);
    setStart(dst);
    setEnd(den);
  };

  return (
    <Box style={{ position: 'relative', marginLeft: 50, marginRight: 50 }}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          style={{
            marginLeft: 10,
            marginRight: 10,
            marginBottom: 3,
            fontWeight: 'bold',
          }}
        >
          {label}
        </Typography>
      </Box>
      <Button
        style={{ position: 'absolute', right: 175, top: -5 }}
        onClick={() => onChange(new Date())}
        variant="contained"
        color="primary"
      >
        <Typography style={{ fontSize: 12, fontWeight: 'bold' }}>
          {isRTL ? 'اليوم' : 'Today'}
        </Typography>
      </Button>
      <DatePicker
        selected={start}
        onChange={onChange}
        locale={isRTL ? ar : en}
        calendarStartDay={6}
        inline
      />
    </Box>
  );
};

export default CalenderRange;
